import striptags from 'striptags';

/**
 * Creates a deep clone of an object.
 * @param obj The object to clone.
 * @returns The cloned object.
 */
export function cloneDeepObject<T extends object>(obj: T): T {
  const clonedObj: Partial<T> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      clonedObj[key as keyof T] = isObject(value)
        ? cloneDeepObject(value)
        : value;
    }
  }

  return clonedObj as T;
}

/**
 * Creates a deep clone of an array.
 * @param arr The array to clone.
 * @returns The cloned array.
 */
export function cloneDeepArray<T>(arr: T[]): T[] {
  return arr.map((item) => {
    if (Array.isArray(item)) {
      return cloneDeepArray(item) as any;
    } else if (isObject(item)) {
      return cloneDeepObject(item) as any;
    } else {
      return item;
    }
  }) as T[];
}
/**
 * Checks if a value is an object.
 * @param value The value to check.
 * @returns Returns true if the value is an object
 */
export function isObject(value: unknown): value is object {
  return typeof value === 'object' && value !== null;
}

export function sanitizePossibleHTMLContent(content: string): string {
  if(content === null) content = '';
  const regex1 = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  const regex2 = /<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi;
  const regex3 = /<img .*?>/gi;
  const cleaned = content
    .replace(regex1, '')
    .replace(regex2, '')
    .replace(regex3, '');

  const allowedTags = [
    'b',
    'br',
    'strong',
    'ul',
    'ol',
    'li',
    'i',
    'p',
    'blockquote',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
  ];
  return striptags(cleaned, allowedTags);
}
